/** 停放车辆分析 */
import { GetParkingVehicleAnalysis,GetMonthCardAnalysis,GetParkingVehicleAnalysisActive} from '@/services/api'
import { useRequest } from 'ahooks'
import { Spin } from 'antd'
import ReactEcharts from 'echarts-for-react';
import React, { useCallback, useState,useMemo, useEffect } from 'react'
import Panel from '@/components/Panel'
import styles from './style.module.scss'
import { Pie } from '@ant-design/charts';
import { autorun } from 'mobx'
import ImgSource from '@/assets/img/resource/resource.png'
import Abutton from '@/components/Abutton'
export interface ParkikngResourceProps {
  areaCode?: string
}
/** 统计首页跳转地址 */
const iframeURL ="http://lz.dgjx0769.com/lz/#/UrbanIntegration/BasicDataManage/BasicData";
const ParkikngResource: React.FC<ParkikngResourceProps> = (props) => {
    const [ setData] = useState({});
 
  const service = useCallback(() => {
    // return GetDistributeData(  props.areaCode )
    return GetParkingVehicleAnalysis(  {areaCode: props.areaCode} )
  },[props.areaCode])
  const service2 = useCallback(() => {
    // return GetDistributeData(  props.areaCode )
    return GetMonthCardAnalysis(  {areaCode: props.areaCode} )
  },[props.areaCode])
  const service3 = useCallback(() => {
    // return GetDistributeData(  props.areaCode )
    return GetParkingVehicleAnalysisActive(  {areaCode: props.areaCode} )
  },[props.areaCode])

  const { loading, data=[], error } = useRequest(service, {
    formatResult: res => {
      return res.data.map((item:any)=>{
        return {
          name:item.typeName,
          value:item.count
        }
      })
    }
  })

  const { loading: monthCardLoading, data: monthCardData=[], error: monthCardError } = useRequest(service2, {
    formatResult: res => {
      return res.data.map((item:any)=>{
        return {
          name:item.typeName,
          value:item.count
        }
      })
    }
  })

  const { loading: activeLoading, data: activeData=[], error: activeError } = useRequest(service3, {
    formatResult: res => {
      return [
        {
          name:'活跃汽车数量',
          value:res.data.activeCount
        },
        {
          name:'机动车保有量',
          value:res.data.carCount
        }
      ]
    }
  })
  if (error && loading === false) {
    <Panel
      title="停放车辆分析"
    >
      <div className="fetch_container" style={{ height: 89 }}>
        请求错误
      </div>
    </Panel>
  }
  const piedata2:any = []
  const piedata1 = [...data, ...monthCardData]


/**图标数据 */
const AbuttonBox = useMemo(() => {
  return <Abutton  iframeURL={iframeURL} text={''}/>
}, [])

let Option = {
  tooltip: {
    trigger: 'item',
    formatter: '{b}: {c} ({d}%)'
  },

  series: [
    {
      
      center: ['50%', '60%'],
      type: 'pie',
      selectedMode: 'single',
      radius: [0, '30%'],
      color:['#00ccff','#6772ff','#008aff'],
      label: {
        color: 'rgba(32, 188, 252, 1)',
        formatter: (params:any) => {
          return `${params.name}(${params.value})`;
        }
      },
      avoidLabelOverlap:true,
      labelLine: {
        length: 40
      },
      
      data:activeData
    },
    {
     
      type: 'pie',
      radius: ['40%', '55%'],
      center: ['50%', '60%'],
      labelLine: {
        length: 20,
        length2:5
      },
      avoidLabelOverlap:true,
      label: {
        color: 'rgba(32, 188, 252, 1)',
        formatter: (params:any) => {
          return `${params.name}(${params.value})`;
        }
      },
      color:['#2dbcdf','#6275d5','#4aa3e2'],
      data:piedata1
    }
  ]
};

  return (
    <Panel
      title="停放车辆分析"
    >
           
           {
        loading ?
          <div className="fetch_container" style={{ height: 120 }}>
            <Spin/>
          </div> :
          <ReactEcharts
          option={Option}
          style={{height: '240px', width: '420px'}}
          className='react_for_echarts' 
          />

      }
    </Panel>
  )
}

export default ParkikngResource
